<script lang="ts">
  export let disabled: boolean = false;
  let className: string = "";
  const baseClass = `${className} rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500 disabled:opacity-50`;
  export { className as class };
</script>

<button {disabled} class={baseClass} on:click><slot /></button>
